const products = document.querySelectorAll(".coa__product-card");
const searchBar = document.getElementById("coa-search-bar");
const drawer = document.getElementById("coa-drawer");
const drawerTitle = document.getElementById("coa-drawer-title");
const closeDrawerBtn = document.getElementById("coa-drawer-close-btn");
const labResultsContainer = document.getElementById("coa-drawer-lab-results");
const ingredientsList = document.getElementById("coa-drawer-ingredients-list");
const drawerCTA = document.getElementById("coa-drawer-CTA");
const backdrop = document.getElementById("coa-backdrop");
const modal = document.getElementById("coa-modal");
const closeModalBtn = document.getElementById("coa-modal-close-btn");
const openPdfCTA = document.getElementById("open-pdf-CTA");
const iframe = document.getElementById("lab-report-pdf-iframe");

// Helper to display or hide an element
function toggleDisplay(element, isVisible) {
  element.style.display = isVisible ? "block" : "none";
}

// Helper to safely parse JSON with a fallback value
function parseJSON(data, fallbackValue = null) {
  try {
    return JSON.parse(data);
  } catch (error) {
    console.error("JSON parsing error:", error);
    return fallbackValue;
  }
}

function handleProductSearch() {
  const searchQuery = this.value.toLowerCase().trim();

  products.forEach((product) => {
    const productName =
      product.getAttribute("data-product-title")?.toLowerCase() || "";
    const batchNumber =
      product.getAttribute("data-product-batch-number")?.toLowerCase() || "";
    toggleDisplay(
      product,
      productName.includes(searchQuery) || batchNumber.includes(searchQuery)
    );
  });
}

searchBar.addEventListener("input", handleProductSearch);

function handleLabResults(productItem) {
  const labResultsData =
    productItem.getAttribute("data-product-lab-results") || "{}";
  const productLabResults = parseJSON(labResultsData, {});

  if (
    !productLabResults?.children ||
    !Array.isArray(productLabResults.children)
  ) {
    labResultsContainer.textContent = "No lab results available.";
    return;
  }

  const hasComingSoon = productLabResults.children.some((child) =>
    child.children?.some((innerChild) =>
      innerChild?.value?.toLowerCase().includes("coming soon")
    )
  );

  if (hasComingSoon) {
    labResultsContainer.textContent = "Lab results coming soon!";
    return;
  }

  const fragment = document.createDocumentFragment();

  productLabResults.children.forEach((child) => {
    child.children?.forEach((innerChild) => {
      if (innerChild?.type === "link" && innerChild.url?.includes(".pdf")) {
        const labResultLink = document.createElement("button");
        labResultLink.type = "button";
        labResultLink.textContent = innerChild.children?.[0]?.value;
        labResultLink.classList.add("coa__drawer-lab-result-link");
        labResultLink.addEventListener("click", () =>
          openModal(innerChild.url)
        );
        fragment.appendChild(labResultLink);
      }
    });
  });

  labResultsContainer.appendChild(fragment);

  if (labResultsContainer.children.length === 0) {
    labResultsContainer.textContent = "No lab results available.";
  }
}

function handleIngredients(productItem) {
  const productIngredientsData =
    productItem.getAttribute("data-product-ingredients") || "{}";
  const productIngredients = parseJSON(productIngredientsData, {});
  const firstChildChildren = productIngredients?.children?.[0]?.children || [];
  const hasIngredients =
    firstChildChildren.length > 0 &&
    firstChildChildren.every((child) => child.type === "list-item");

  if (hasIngredients) {
    const fragment = document.createDocumentFragment();
    firstChildChildren.forEach((child) => {
      const ingredientValue = child?.children?.[0]?.value?.trim();
      if (ingredientValue) {
        const li = document.createElement("li");
        li.textContent = ingredientValue;
        fragment.appendChild(li);
      }
    });
    ingredientsList.appendChild(fragment);
  } else {
    const noIngredientsMessage = document.createElement("p");
    noIngredientsMessage.textContent = "No ingredients available";
    ingredientsList.appendChild(noIngredientsMessage);
  }
}

function handleProductClick(item) {
  drawerTitle.textContent = item.getAttribute("data-product-title");
  drawerCTA.href = item.getAttribute("data-product-url");
  handleLabResults(item);
  handleIngredients(item);
  drawer.classList.add("open");
  toggleDisplay(backdrop, true);
}

products.forEach((item) =>
  item.addEventListener("click", () => handleProductClick(item))
);

function closeDrawer() {
  drawer.classList.remove("open");
  toggleDisplay(backdrop, false);
  labResultsContainer.innerHTML = "";
  ingredientsList.innerHTML = "";
}

closeDrawerBtn.addEventListener("click", closeDrawer);
backdrop.addEventListener("click", closeDrawer);

function openModal(url) {
  modal.classList.toggle("visible");
  document.body.classList.add("modal-open");
  iframe.src = url;
  openPdfCTA.href = url;
}

function closeModal() {
  modal.classList.toggle("visible");
  document.body.classList.remove("modal-open");
  iframe.src = "";
}

closeModalBtn.addEventListener("click", closeModal);

// Close the modal when clicking outside the modal content
window.addEventListener("click", function (event) {
  if (event.target === modal) {
    closeModal();
  }
});
